var Config = {
	debug_mode : false,
	
	isTouchDevice:function(){
		return typeof window.ontouchstart !== 'undefined';
	}
}